import { StayingPlace } from 'common/types';
import { Co2FootprintVO } from 'vo/Co2FootprintVO';

/**
 * Base accommodation emission factor updated January 2026.
 * Derived from DEFRA 2025 hotel stay factor (10.4 kg CO2e/room-night)
 * adjusted for average occupancy (~1.3 persons/room).
 * Source: https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2025
 */
const FRANCE_RERSON_PER_NIGHT_CO2E_KG = 8.0;

/**
 * Hotel class coefficients from Cornell Hotel Sustainability Benchmarking (CHSB) 2024.
 * https://www.hotelfootprints.org/
 */
const EMISSION_COEFFICIENT_BY_STAYING_PLACE: Record<StayingPlace, number> = {
  [StayingPlace.HOTEL_2_STARS]: 0.33,
  [StayingPlace.HOTEL_3_STARS]: 0.5,
  [StayingPlace.HOTEL_4_STARS]: 1.14,
  [StayingPlace.HOTEL_5_STARS]: 1.86,
  [StayingPlace.PRIVATE_ACCOMODATION]: 0.2, // taken from the head
};

type Params = {
  peopleCount: number;
  tripDaysCount: number;
  stayingPlace: StayingPlace;
};

export default (params: Params) => {
  const { peopleCount, tripDaysCount, stayingPlace } = params;
  const coeff = EMISSION_COEFFICIENT_BY_STAYING_PLACE[stayingPlace];

  const perPerson = FRANCE_RERSON_PER_NIGHT_CO2E_KG * coeff * tripDaysCount;
  const total = perPerson * peopleCount;

  return Co2FootprintVO.create({ perPerson, total });
};
